var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmile = function SvgSmile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA221",
    d: "M41.863 36.64c-2.408 4.698-7.141 7.907-12.588 7.907s-10.18-3.209-12.588-7.907l-7.904 1.978c3.409 8.184 11.304 13.939 20.492 13.939s17.083-5.755 20.492-13.94zM48.791 18.09a5.62 5.62 0 1 1-11.24 0 5.62 5.62 0 0 1 11.24 0M23.77 16.696 8.514 9.846v3.679l10.605 4.565-10.605 4.565v3.679l15.256-6.85z"
  })));
};
export default SvgSmile;